import {Prop, Vue} from "vue-property-decorator";

export default class extends Vue {
    @Prop() readonly dataSource: string;
    @Prop() readonly filter!: object;
    @Prop() readonly index: number;

    protected splitColumns: boolean = false;
    protected filtersToShow: number = 0;
    protected filterCollapsed: boolean = false;
    protected filterOpen: boolean = ! this.$mobileDetect.mobile();

    public created(): void {
        this.splitColumns = (this.filter['layout'] || '') === '2columns';
        this.filtersToShow = this.splitColumns ? 10 : 5;
        this.filterCollapsed = this.filter['options'].length > this.filtersToShow;
        if (this.index > 3) {
            this.filterOpen = false;
        }
    }

    protected toggleFilterValueCollapse(): void {
        this.filterCollapsed = ! this.filterCollapsed;
    }

    protected filterIsVisibleCheck(index: number): boolean {
        return this.filterCollapsed ? index < this.filtersToShow : true;
    }

    protected toggleFilter(): void {
        this.filterOpen = ! this.filterOpen;
    }

    protected async toggleFilterStatus(option: object): Promise<void> {
        await this.$store.dispatch(`${this.dataSource}/toggleFilter`, {filter: this.filter, option: option});
    }
}
